/** QC Physical Purity Data Verification (deck `Physical Purity.pptx` slide 9): the Review link off the list. */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { PpReviewPage } from "@/features/quality/components/pp/pp-review-page";

export const Route = createFileRoute("/_app/quality/pp/$sampleId")({
  params: {
    parse: ({ sampleId }) => {
      if (!/^\d+$/.test(sampleId)) throw notFound();
      return { sampleId };
    },
    stringify: (p) => p,
  },
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.verify")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { sampleId } = Route.useParams();
  return <PpReviewPage id={Number(sampleId)} />;
}
